import { createSvgComponent } from "../../icon/createSvgComponent";
import ChevronrleftDouble from "@core/__generated__/icon/figma/chevronrleft-double.svg";
export default createSvgComponent(ChevronrleftDouble);